import each from 'lodash/each';
import isArray from 'lodash/isArray';
import isNaN from 'lodash/isNaN';
import map from 'lodash/map';
function retrieveValue(value) {
  if (value instanceof Date) {
    return value.toISOString();
  }
  return value;
}
export function queryString(query) {
  return map(query, function (value, key) {
    if (value === undefined || value === null) {
      return;
    }
    if (isArray(value)) {
      return map(value, function (item) {
        return key + '[]=' + retrieveValue(item);
      }).join('&');
    }
    return key + '=' + retrieveValue(value);
  }).filter(Boolean).join('&');
}
function parseValue(value) {
  if (value === 'true') {
    return true;
  }
  if (value === 'false') {
    return false;
  }
  const integer = parseInt(value, 10);
  if (String(integer) === value) {
    return integer;
  }
  const number = parseFloat(value);
  if (String(number) === value) {
    return number;
  }
  const date = new Date(value);
  if (!isNaN(date.getTime()) && date.toISOString() === value) {
    return date;
  }
  return value;
}
export function parseQuery(query, filter) {
  if (!query) {
    return {};
  }
  const props = {};
  each(decodeURIComponent(query).split('&'), function (part) {
    const queryPair = part.split('=');
    let key = queryPair[0];
    const value = parseValue(queryPair[1]);
    if (filter && filter(key, value) === false) {
      return;
    }
    if (key.indexOf('[]') === key.length - 2) {
      // key is an array

      key = key.replace('[]', '');
      if (!props[key]) {
        props[key] = [];
      }
      ;
      props[key].push(value);
    } else {
      props[key] = value;
    }
  });
  return props;
}